//Codes des applications de la plateforme soumises à autorisation
//  Ces codes sont la clé fonctionnelle des lignes de la table APPLICATION d'Ammon
//  Permissions, et c'est le code qui circule : dans le jeton de contexte utilisateur,
//  dans les gardes de route et dans l'attribut d'autorisation des APIs.
//
//  Ne pas confondre avec les modules de licence du serveur de licences, qui disent ce
//  que le client a acheté : ici ce sont les groupes qui pilotent, et l'objet est
//  l'utilisateur. Cf. ADR-0017 du dépôt ammon-plateforme-docs.
export const ApplicationsPlateforme =
{
  //Ammon eFacture
  eFacture: "EFACT",

  //Ammon Services
  services: "SERVICES"
} as const;
